/**
 * Maps a tenant color scheme name to concrete hex pairs.
 *
 * Mirrors the CSS schemes declared in `App.css` (`--orange-primary` and
 * `--orange-light` for each `[data-color-scheme="…"]` block). Kept in
 * sync with that file — update both if a new scheme is added.
 *
 * `primary` is the brand color; `light` is the brighter accent already
 * defined per scheme — used as the natural "secondary" pair.
 */

export type ColorScheme = 'default' | 'orange' | 'blue' | 'green' | 'purple' | 'red';

export interface ThemeColorPair {
  primary: string;
  light: string;
}

const SCHEME_HEX: Record<ColorScheme, ThemeColorPair> = {
  default: { primary: '#ff8c00', light: '#ffa64d' },
  orange:  { primary: '#ff8c00', light: '#ffa64d' },
  blue:    { primary: '#3182ce', light: '#63b3ed' },
  green:   { primary: '#38a169', light: '#68d391' },
  purple:  { primary: '#805ad5', light: '#b794f4' },
  red:     { primary: '#e53e3e', light: '#fc8181' },
};

export const getSchemeColors = (scheme: string | undefined | null): ThemeColorPair => {
  if (scheme && scheme in SCHEME_HEX) {
    return SCHEME_HEX[scheme as ColorScheme];
  }
  return SCHEME_HEX.default;
};
